import React from "react"
import { Flex, Image } from "@chakra-ui/react"
import appleWalletLogo from "assets/images/apple-wallet-logo.png"
import googleWalletLogo from "assets/images/google-wallet-logo.png"
import googleWalletLogoSm from "assets/images/google-wallet-logo-sm.png"
import { DROP_ZONE_BORDER } from "./passBuilderTokens"

export type PlatformIconVariant = "field" | "tab"

type GoogleIconProps = {
  variant?: PlatformIconVariant
}

export const GoogleIcon = ({ variant = "field" }: GoogleIconProps) => {
  if (variant === "tab") {
    return (
      <Flex
        w="34px"
        h="34px"
        borderRadius="full"
        bg="white"
        borderWidth="1px"
        borderColor={DROP_ZONE_BORDER}
        align="center"
        justify="center"
        flexShrink={0}
      >
        <Image src={googleWalletLogo} w="22px" h="22px" alt="" />
      </Flex>
    )
  }

  return (
    <Flex
      w="20px"
      h="20px"
      borderRadius="full"
      bg="white"
      borderWidth="1px"
      borderColor="gray.300"
      align="center"
      justify="center"
      flexShrink={0}
    >
      <Image src={googleWalletLogoSm} w="13px" h="13px" alt="" />
    </Flex>
  )
}

type AppleIconProps = {
  variant?: PlatformIconVariant
}

export const AppleIcon = ({ variant = "field" }: AppleIconProps) => (
  <Image
    src={appleWalletLogo}
    w={variant === "tab" ? "30px" : "20px"}
    h={variant === "tab" ? "30px" : "20px"}
    flexShrink={0}
    display="inline-block"
    alt=""
  />
)
